<template>
  <v-autocomplete
    class="soraban-autocomplete-field"
    append-icon="expand_more"
    outline
    :items="items"
    :hint="hint"
    :persistent-hint="true"
    :error-count="1"
    :error-messages="errorMessages"
    :disabled="disabled"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    :return-object="returnObject"
    :loading="loading"
    :hide-no-data="loading"
    v-bind="$attrs"
    v-model="valueAlias"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
    @change="$emit('change', value)"
  >
  </v-autocomplete>
</template>

<script>
export default {
  name: 'SorabanAutocomplete',
  props: {
    value: {
      required: false,
      type: [String, Number, Object],
      default: '',
    },
    itemValue: {
      required: false,
      type: String,
      default: '',
    },
    itemText: {
      required: false,
      type: String,
      default: '',
    },
    returnObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    loading: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    items: {
      required: true,
      type: Array,
      default: () => [],
    },
    errorMessage: {
      required: false,
      type: String || null,
      default: null,
    },
    label: {
      required: true,
      default: '',
      type: String,
    },
    hint: {
      required: false,
      default: '',
      type: String,
    },
  },
  computed: {
    errorMessages() {
      return this.errorMessage ? [this.errorMessage] : null;
    },
    valueAlias: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped lang="postcss">
.soraban-autocomplete-field >>> {
}
</style>
